'use client';

import React from 'react';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-solid-svg-icons';
import { PulseButton } from 'src/components';
import { useSite } from 'src/context/providers/SiteProvider';
import {
  useAppSelector,
  useAppDispatch,
  selectNavItems,
  selectNavCurrentIndex,
  selectNavTotalCount,
  selectHasNav,
  setNavIndex,
} from 'src/redux';

const ProfileDrawerNav: React.FC = () => {
  const { dispatch: siteDispatch } = useSite();
  const appDispatch = useAppDispatch();

  const items = useAppSelector(selectNavItems);
  const currentIndex = useAppSelector(selectNavCurrentIndex);
  const totalCount = useAppSelector(selectNavTotalCount);
  const hasNav = useAppSelector(selectHasNav);

  if (!hasNav) return null;

  const handlePrev = () => {
    const newIndex = Math.max(currentIndex - 1, 0);
    appDispatch(setNavIndex(newIndex));
    const item = items[newIndex];
    if (item) {
      siteDispatch({
        type: 'SET_CURRENT_PROVIDER',
        payload: { id: item.id, type: item.type },
      });
    }
  };

  const handleNext = () => {
    const newIndex = Math.min(currentIndex + 1, items.length - 1);
    appDispatch(setNavIndex(newIndex));
    const item = items[newIndex];
    if (item) {
      siteDispatch({
        type: 'SET_CURRENT_PROVIDER',
        payload: { id: item.id, type: item.type },
      });
    }
  };

  return (
    <div
      className="px-4 py-2 w-full flex items-center justify-between bg-sky-900"
      data-testid="profile-drawer-nav"
      role="navigation"
      aria-label="Provider navigation"
    >
      <PulseButton
        variant="plain"
        size="sm"
        startDecorator={faChevronLeft}
        className="h-6 text-white rounded-md bg-neutral-50/5 disabled:opacity-50
            disabled:bg-transparent hover:enabled:bg-neutral-50/10"
        onClick={handlePrev}
        disabled={currentIndex === 0}
        aria-label="Previous provider"
      >
        Prev
      </PulseButton>
      <div className="text-xs text-white font-medium" aria-live="polite">
        {currentIndex + 1} of {totalCount}
      </div>
      <PulseButton
        variant="plain"
        size="sm"
        endDecorator={faChevronRight}
        className="h-6 text-white rounded-md bg-neutral-50/5 disabled:opacity-50
            disabled:bg-transparent hover:enabled:bg-neutral-50/10"
        onClick={handleNext}
        disabled={currentIndex >= items.length - 1}
        aria-label="Next provider"
      >
        Next
      </PulseButton>
    </div>
  );
};

export default ProfileDrawerNav;
